import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { AuthProvider } from 'fluid-auth';
import { Loader } from 'yw-ui.v2';
import App from './App';
import configureStore, { history } from './store';

import 'yw-ui.v2/dist/css/yw-ui.v2.min.css';
import { authOptions } from './common/settings';
import { MainLayout } from './scenes/layouts';

const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <Router basename="/priority-services" history={history}>
      <AuthProvider
        store={store}
        history={history}
        {...authOptions}
        ignoreRoles
        loadingRenderer={() => (
          <MainLayout>
            <Loader message="Loading..." />
          </MainLayout>
        )}
      >
        <App />
      </AuthProvider>
    </Router>
  </Provider>,
  document.getElementById('root'),
);
